@if(!formulaEditing){
<div class="row">
  <div class="col-12">
      <h1 class="page-header"><i class="fas fa-cog"></i> Cuentas de sueldo de Referencia</h1>

  </div> 
   
</div>

@if(employeeType?.length>1){
  <div class="row">
      <div class="col-12">
          <!-- begin panel -->
          <ul class="nav nav-tabs">
              @for(b of employeeType; track b.id;let i = $index){
              <li class="nav-item">
                  <a [href]="'#'+b.id" data-bs-toggle="tab" (click)="tabChange(b)" class="nav-link"
                  [class.active]="employeeTypeSelected ==b.id">{{b.name}}</a>
              </li>
              }
          </ul>
      </div>
  </div>
}
<div class="tab-content panel p-4 " [ngClass]="{ 'rounded-0 rounded-bottom': employeeType?.length>1 }">
  <div class="row mb-3 mt-2">
    <div class="col-12 d-flex justify-content-end">
      <button class="btn btn-success text-white m-r-10" (click)="openModalAccount()">Agregar Cuenta</button>
    </div>
  </div>


  <mat-table #table [dataSource]="dataSource" class="mat-elevation-z8" cdkDropListData="dataSource" cdkDropList
    (cdkDropListDropped)="drop($event)">
    <ng-container matColumnDef="order">
      <mat-header-cell *matHeaderCellDef style="flex: 0 0 65px;">Orden </mat-header-cell>
      <mat-cell *matCellDef="let element" style="flex: 0 0 65px;">
        <span><i class="fa-solid fa-grip-vertical"></i></span>&nbsp;&nbsp;
        <span>{{element.order}}</span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="accountCode">
      <mat-header-cell *matHeaderCellDef style="flex: 0 0 90px;"> Cuenta </mat-header-cell>
      <mat-cell *matCellDef="let element" style="flex: 0 0 90px;">{{element.accountCode}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="accountName">
      <mat-header-cell *matHeaderCellDef> Nombre para Mostrar </mat-header-cell>
      <mat-cell *matCellDef="let element" (click)="enableEditing(element,'accountName')" class="editable-span text-nowrap">
        <span>
          {{ element.accountName || '-' }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="hint">
      <mat-header-cell *matHeaderCellDef >Info de Cuenta</mat-header-cell>
      <mat-cell *matCellDef="let element;let i =index" (click)="enableEditing(element,'Hint')" class="editable-span"
        >
        @if(!element.isEditingHint){
        <span>
          {{ element?.hint?.slice(0,60)|| '-' }}
        </span>
        }
        @if(element.isEditingHint){
        <div class="textarea-container">
          <textarea #input class="editable-textarea form-control form-control-sm" [value]="element.hint"
            (blur)="updateItemsAccount(element, 'hint', input.value); element.isEditingHint = false;element.hint=input.value"
            (keydown.enter)="updateItemsAccount(element, 'hint', input.value); element.isEditingHint = false;element.hint=input.value"
            (focus)="autoGrow($event)" (input)="autoGrow($event)" rows="1">
          </textarea>
        </div>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="block">
      <mat-header-cell *matHeaderCellDef style="flex: 0 0 80px;"> Bloquear </mat-header-cell>
      <mat-cell *matCellDef="let element" style="flex: 0 0 80px;">
        <input #block class="form-check-input" type="checkbox" [checked]="element.block"
          (change)="updateItemsAccount(element,'block',block.checked)"></mat-cell>
    </ng-container>


    <ng-container matColumnDef="setting">
      <mat-header-cell *matHeaderCellDef style="flex: 0 0 100px;"> <i class="fa-solid fa-gear"></i></mat-header-cell>
      <mat-cell *matCellDef="let element" style="flex: 0 0 100px;">
        <button class="btn btn-outline-danger btn-xs" (click)="deleteItemsAccount(element)"><i
            class="fa-solid fa-trash"></i>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" cdkDrag [cdkDragData]="row"></mat-row>
  </mat-table>

  <br>

</div>
}
@if(formulaEditing){
  <div class="row">
    <div class="col-12 col-md-6">
        <h1 class="page-header">{{formItemsTravel.get('code').value}} - {{formItemsTravel.get('name').value}}</h1>
  
    </div> 
    <div class="col-12 col-md-6">
      <div class=" d-md-flex fw-bold justify-content-end">
          <div class="mt-3">
            <a href="javascript:;" class="btn btn-xs btn-success me-2"
            (click)="submitEditItems()"><i
            class="fa fa-save fa-fw me-1"></i> Guardar</a>
                       <a href="javascript:;" class="btn btn-xs btn-outline-danger"
                       (click)="formulaEditing=false;resetForm()"><i
                              class="fa fa-times fa-fw me-1"></i> Cancelar</a>
                          
          </div>
      </div>
  </div>
     
  </div>
<div class="panel p-4 ">
    <form [formGroup]="formItemsTravel">
      <div class="table-data">
        <ngx-monaco-editor
          formControlName="calculation"
          [options]="editorOptions"
          (onInit)="onMonacoInit()" [container]="'body'">
        </ngx-monaco-editor>
      </div>
    </form>

</div>
}

<ng-template #modal_account let-c="close" let-d="dismiss" let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Agregar Item</h5>
    <button (click)="d('Cross click')" type="button" class="btn-close bt-xs" data-dismiss="modal" tabindex="7">
      <span></span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="formAccountSalaryRef">
      <div class="form-group row">
        <label class="col-md-4 col-form-label">Cuenta</label>
        <div class="col-md-8">
          <ng-select #ngSelect [hideSelected]="true" [items]="account" bindLabel="nameCode" [closeOnSelect]="true"
            [dropdownPosition]="'bottom'" bindValue="code" placeholder="Escribe una cuenta o codigo"
            formControlName="accountCode" name="accountCode"  tabindex="1">
          </ng-select>
          @if(formAccountSalaryRef.get('accountCode')?.errors?.required &&
          formAccountSalaryRef.get('accountCode').touched){
          <div><small class="text-danger">Cuenta es requerida.</small></div>
          }
        </div>
      </div>&nbsp;
       <div class="form-group row">
        <label class="col-md-4 col-form-label">Inf Campo</label>
        <div class="col-md-8">
          <input type="text"
            [class.is-invalid]="formAccountSalaryRef.get('hint').invalid&&formAccountSalaryRef.get('hint').touched"
            (click)="formAccountSalaryRef.get('hint').markAsUntouched();"
            (focus)="formAccountSalaryRef.get('hint').markAsUntouched();" formControlName="hint" name="hint"
            class="form-control" tabindex="2" />
          @if(formAccountSalaryRef.get('hint')?.errors?.required && formAccountSalaryRef.get('hint').touched){
          <div><small class="text-danger">Campo es requerido.</small></div>
          }
        </div>
      </div>


    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-sm" (click)="d('Cross click'); resetForm()"><i
        class="fas fa-times"></i>&nbsp; Cerrar</button>
    <button type="button" class="btn btn-primary btn-sm" (click)="submitNewItems()" tabindex="4"><i
        class="fas fa-save"></i>&nbsp;Guardar</button>


  </div>

</ng-template>